import { cn } from '../lib/utils'
import { CopyButton } from './copy-button'

/**
 * CopyField — readonly-значение (ссылка, адрес, ключ) + пилюля «Скопировать».
 * Без рамок: форму дают заливка `bg-foreground/10` и скругление. По ширине — по
 * содержимому (адрес и кнопка рядом); растянуть можно `className="w-full"`. Копирование
 * делает <CopyButton> (тост и подпись «Скопировано» на 2 сек.).
 */
export interface CopyFieldProps {
  value: string
  /** подпись пилюли в покое (по клику всегда «Скопировано»); дефолт «Скопировать» */
  copyLabel?: string
  /** текст тоста при успехе; дефолт «Скопировано» */
  toastText?: string
  /** моноширинный шрифт значения (для токенов/ключей) */
  mono?: boolean
  className?: string
}

export function CopyField({
  value,
  copyLabel,
  toastText,
  mono = false,
  className,
}: CopyFieldProps) {
  return (
    <div
      className={cn(
        'flex w-fit max-w-full items-center justify-between gap-6 rounded-2xl bg-foreground/10 py-2 pl-4 pr-2',
        className,
      )}
    >
      <span
        className={cn(
          'min-w-0 flex-1 truncate text-sm text-muted-foreground select-all',
          mono && 'font-mono',
        )}
      >
        {value}
      </span>
      <CopyButton value={value} label={copyLabel} toastText={toastText} />
    </div>
  )
}
